export default __webpack_public_path__ + "static/media/loryF2P.833123a5.png";